import { TFunction } from 'i18next';

export function buildImportDetailsMessage(
  t: TFunction<'eleve'>,
  {
    newElevesCount,
    updatedElevesCount,
    ignoredElevesCount,
    existingUnaffectedElevesCount,
  }: {
    newElevesCount: number;
    updatedElevesCount: number;
    ignoredElevesCount: number;
    existingUnaffectedElevesCount: number;
  },
): string {
  const newElevesMessage = t('import.newCount', { count: newElevesCount });
  const updatedElevesMessage = t('import.updatedCount', {
    count: updatedElevesCount,
  });
  const ignoredElevesMessage = t('import.ignoredCount', {
    count: ignoredElevesCount,
  });
  const unaffectedElevesMessage = t('import.existingUnaffectedCount', {
    count: existingUnaffectedElevesCount,
  });

  return ` (${newElevesMessage} / ${updatedElevesMessage} / ${ignoredElevesMessage} / ${unaffectedElevesMessage})`;
}
